// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__2Rh_f"};